import { ApiClient } from '../lib/api';
import { Job, JobSchema } from '../models/job';

export class JobService {
    private api: ApiClient;

    constructor(baseURL: string, stage: string) {
        this.api = new ApiClient(`${baseURL}/${stage}/jobs-service-${stage}`, stage);
    }

    private setDefaults(data: unknown): Job {
        return JobSchema.parse(data);
    }

    async getAllJobs(): Promise<Job[]> {
        const jobs = await this.api.request(
            { method: 'GET', url: '/jobs' },
            JobSchema.array()
        );
        return jobs.map(job => this.setDefaults(job));
    }

    async getJobById(id: number): Promise<Job> {
        const job = await this.api.request(
            { method: 'GET', url: `/jobs/${id}` },
            JobSchema
        );
        return this.setDefaults(job);
    }
} 